import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'


const getAddressesByCity = async (obj) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + `adresses/streets/${obj}`);
    return (dFromF.data);
}

const getStreetsWithZoneByCity = async (cityName) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + `adresses/streetsWithZones/${encodeURIComponent(cityName)}`);
    return (dFromF.data);
}


export default {
    getAddressesByCity,
    getStreetsWithZoneByCity
};



